import { Container, ContactOptions, FormContact, Footer } from '../components';
import styled from 'styled-components';
import '../animation/boundInDown.css';

const Contact = () => {
  return (
    <>
      <Container>
        <ContactWrapper className="bounceInUp">
          <ContactOptions />
          <FormContact />
        </ContactWrapper>
      </Container>
      <Footer />
    </>
  );
};
const ContactWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 92%;
  justify-content: space-between;
  padding: 0 10rem;
  padding-top: 5rem;
`;

export default Contact;
